import ConfigService from '../index'
class RmService extends ConfigService {
    constructor(){
        super('rm/api/v1/')
    }
    async get_user_rm(params){
        return await this.get('rm/get_username/', params)
    }
    async get_info_aluno(params){
        return await this.get('rm/info_aluno/', params)
    }
    async ativa_aluno(data){
        return await this.post('rm/ativa_aluno/', data) //{user:"code_user"}
    }
    async get_caderno_formando(params){
        return await this.get('caderno/formando/', params)
    }
    async get_caderno_concluintes(params){
        return await this.get('caderno/concluintes_pos/', params)
    }
    async get_aluno_imagem(matricula){
        return await this.get(`rm/${matricula}/get_aluno_imagem/`,)
    }
    async set_aluno_imagem(data){
        return await this.post(`rm/${data.codpessoa}/set_aluno_imagem/`, data.payload)
    }
    async enturmar(data){
        return await this.post(`rm/enturmar/`, data)
    }
    async pletivos_enturmar(){
        return await this.get(`rm/pletivos_enturmar/`)
    }
    async pletivos(data={}){
        return await this.post(`rm/pletivos/`, data)
    }
    async scursos(params={}){
        return await this.get(`rm/scursos/`, params)
    }
    async sturma_enturmar(params){
        return await this.get(`rm/sturma_enturmar/`,params)
    }
    async lista_ra_enturmar(params){
        return await this.get(`rm/lista_ra_enturmar/`,params)
    }
    async set_data_lancamentos(data){
        return await this.post(`rm/set_data_lancamento/`,data)
    }
    async set_migracao_bolsas(data){
        return await this.post(`rm/set_migracao_bolsas/`,data)
    }
    async set_atualiza_parcela(data){
        return await this.post(`rm/set_atualiza_parcela_inicial/`,data)
    }
    async set_nf_rejeitada(data){
        return await this.post(`rm/set_nf_rejeitada/`,data)
    }
    async lista_prouni_complementar(data){
        return await this.post(`rm/atualiza_campo_complementar_prouni/`,data)
    }
    async set_prouni_complementar(data){
        return await this.post(`rm/atualiza_campo_complementar_prouni/`,data)
    }
}
export default RmService
